/* RESPONSIBLE TEAM: team-omni */
import Service from '@ember/service';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Store from '@ember-data/store';
import type Session from 'embercom/services/session';
import type SlackIntegrationModel from 'embercom/models/slack/integration';

export default class SlackIntegrationService extends Service {
  @service declare store: Store;
  @service declare session: Session;

  @tracked hasStaleIntegration = false;
  @tracked existingIntegrationsIds: string[] | null = null;

  async loadIntegration(): Promise<void> {
    if (!this.session.workspace.isFeatureEnabled('team-omni-slack')) {
      return;
    }

    try {
      let integrations = await this.store.query('slack/integration', {
        app_id: this.session.workspace.id,
      });

      this.existingIntegrationsIds = integrations
        .toArray()
        .map((integration: SlackIntegrationModel) => integration.id);
      this.hasStaleIntegration = integrations
        .toArray()
        .some((integration: SlackIntegrationModel) => integration.stale);
    } catch (error) {
      console.error('Error loading Slack integration:', error);
      this.hasStaleIntegration = false;
      this.existingIntegrationsIds = null;
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'slack-integration-service': SlackIntegrationService;
  }
}
